import type { ReactNode } from 'react';

export function EmptyState({ title, description, action }: { title: string; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-line bg-white px-6 py-10 text-center">
      <span className="h-1.5 w-12 rounded-full bg-yellow" aria-hidden="true" />
      <h3 className="font-display text-base font-bold text-ink">{title}</h3>
      {description && <p className="max-w-prose text-sm text-ink-muted">{description}</p>}
      {action}
    </div>
  );
}
